import * as types from '../constants/actionsTypes';

const initialState = {
	list: [],
	loading: false,
	deleting: false,
	error: null,
	detail: null
}

export default function (state = initialState, action) {
	switch(action.type) {
		case types.LOAD_USERS_REQUEST:
		case types.ADD_USER_REQUEST:
		case types.LOAD_USER_DETAILS_REQUEST:
			return {
				...state,
				loading: true
			}
		case types.LOAD_USERS_SUCCESS:
			return {
				...state,
				list: action.users,
				loading: false
			}
		case types.LOAD_USERS_FAILURE:
		case types.LOAD_USER_DETAILS_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error
			}
		case types.DELETE_USER_REQUEST:
			return {
				...state,
				deleting: true
			}
		case types.DELETE_USER_SUCCESS:
			return {
				...state,
				list: action.users,
				deleting: false
			}
		case types.DELETE_USER_FAILURE:
			return {
				...state,
				deleting: false,
				error: action.error
			}
		case types.ADD_USER_SUCCESS:{
			return {
				...state,
				loading: false,
				list: action.users,
				detail: state.detail ? action.users.find(user => user.id == state.detail.id) : null
			}}
		case types.ADD_USER_FAILURE:
			return {
				...state,
				loading: false,
				error: action.error
			};
		case types.LOAD_USER_DETAILS_SUCCESS:
			return {
				...state,
				loading: false,
				detail: action.user
			}
		case types.CLEAR_USER_ERROR:
			return {
				...state,
				error: null
			}
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ./reducers/users.js